<template>
    <div class="expressbox">
       <div>
            <el-steps v-if="expressList.length" finish-status="success" direction="vertical" :active="1">
                <el-step v-for="(item,index) in expressList" :key="index"  :title="item.acceptTime" :description="item.acceptStation"></el-step>
            </el-steps>
            <div v-else>暂无物流信息</div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
import { Loading } from 'element-ui';
export default {
    name: "express",
    props: {
        sdk_order_id : String
    },
    data(){
        return {
            loading : '',
            expressList : []
        }
    },
    methods: {
        Loading : function(text){
            this.loading = Loading.service({
                lock: true,
                text: text,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        alertMsg : function(msg){
            this.$message({
                message: msg,
                type: 'error',
                offset: '300'
            });
        },
        getProcess : function(){
            var that = this;
            var params = {
                "sdk_order_id": this.sdk_order_id
            }
            this.$http.post('/getProcess',params,{
                transformRequest: function (data) {
                    return qs.stringify(data);
                },
            },{emulateJSON: true})
            .then(function(res){ 
                var data = res.data;
                if(data.code == '200' || data.code == 200){
                    that.loading.close();
                    if( data.data.traces.length ){
                        that.expressList = data.data.traces;
                    }
                }else{
                    that.alertMsg('物流详情查询失败1');
                }
            }).catch(function(err){ 
               that.alertMsg('物流详情查询失败2');
            }) 
        }
    },
    mounted:function(){
        this.Loading('正在查询物流详情...');
        this.getProcess()
    },
    watch:{
        sdk_order_id : function(val,oldval){
            this.getProcess()
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
